import { clearFormIdempotencyKey } from '@/platform/storage/formIdempotency'
import {
  FooterActions as Actions,
  type FooterActionsProps,
} from '@/shared/ui/FooterActions'
import { useRouter } from 'next/router'
import { mapFaq } from './maps'
import { useContactState } from './state'

export function FooterActions(
  props: Omit<FooterActionsProps, 'onCancelConfirm'>,
) {
  const { formState, resetState } = useContactState()
  const router = useRouter()
  function cancel() {
    const url = mapFaq[formState.reasonBu] || 'https://faq.flashapp.com.br/'
    resetState()
    clearFormIdempotencyKey('contact')
    void router.push(url)
  }
  return <Actions {...props} onCancelConfirm={cancel} />
}
